export const PRICE_FILTER_OPTIONS = [
  {
    id: 'price-1',
    value: 5,
    labelText: 'Tot €5,-',
  },
  {
    id: 'price-2',
    value: 10,
    labelText: 'Tot €10,-',
  },
  {
    id: 'price-3',
    value: 20,
    labelText: 'Tot €20,-',
  },
  {
    id: 'price-4',
    value: 50,
    labelText: 'Tot €50,-',
  },
];

export const MILEAGE_OPTIONS: { label: string; value: number }[] = [
  { label: 'Alle', value: 0 },
  { label: '2.500 km', value: 2501 },
  { label: '5.000 km', value: 5001 },
  { label: '10.000 km', value: 10001 },
  { label: '20.000 km', value: 20001 },
  { label: '30.000 km', value: 30001 },
  { label: '40.000 km', value: 40001 },
  { label: '50.000 km', value: 50001 },
  { label: '60.000 km', value: 60001 },
  { label: '70.000 km', value: 70001 },
  { label: '80.000 km', value: 80001 },
  { label: '80.000 km', value: 90001 },
  { label: '100.000 km', value: 100001 },
  { label: '125.000 km', value: 125001 },
  { label: '150.000 km', value: 150001 },
  { label: '175.000 km', value: 175001 },
  { label: '200.000 km', value: 200001 },
  { label: '250.000 km', value: 250001 },
  { label: '300.000 km', value: 300001 },
  { label: '400.000 km', value: 400001 },
  { label: '500.000 km', value: 500001 },
  { label: '600.000 km', value: 600001 },
  { label: '700.000 km', value: 700001 },
  { label: '800.000 km', value: 800001 },
  { label: '900.000 km', value: 900001 },
  { label: '1.000.000 km', value: 1000001 },
];

export const FILTERS = {
  toys: ['l1', 'l2', 'price'],
  'car-upgrade': ['l2Category', 'mileage', 'fuel'],
  'upgrade-auto': ['fuel', 'transmission', 'body', 'options'],
  overdrive: ['options'],
};

export const MAX_L2_FILTERS = 3;

export const HIGHLIGHTED_OPTION_IDS = new Set([
  13975, 11787, 13974, 13963, 13964, 11804, 11550, 11795, 11791, 11561, 11564,
]);
